/**
 * @generated SignedSource<<78cdc15593f67f6f4c693aa2a612b674>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaperBookmarkButtonUnbookmarkMutation$variables = {
  id: string;
};
export type PaperBookmarkButtonUnbookmarkMutation$data = {
  readonly unbookmarkPaper: {
    readonly " $fragmentSpreads": FragmentRefs<"PaperBookmarkButtonFragment">;
  };
};
export type PaperBookmarkButtonUnbookmarkMutation = {
  response: PaperBookmarkButtonUnbookmarkMutation$data;
  variables: PaperBookmarkButtonUnbookmarkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaperBookmarkButtonUnbookmarkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Paper",
        "kind": "LinkedField",
        "name": "unbookmarkPaper",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PaperBookmarkButtonFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PaperBookmarkButtonUnbookmarkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Paper",
        "kind": "LinkedField",
        "name": "unbookmarkPaper",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bookmarkCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerBookmarked",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d5c11a64d0adab2233e645c18ab4b28d",
    "id": null,
    "metadata": {},
    "name": "PaperBookmarkButtonUnbookmarkMutation",
    "operationKind": "mutation",
    "text": "mutation PaperBookmarkButtonUnbookmarkMutation(\n  $id: ID!\n) {\n  unbookmarkPaper(id: $id) {\n    ...PaperBookmarkButtonFragment\n    id\n  }\n}\n\nfragment PaperBookmarkButtonFragment on Paper {\n  id\n  bookmarkCount\n  viewerBookmarked\n}\n"
  }
};
})();

(node as any).hash = "d78811e3b6c6c42730b78a4c3d2745e8";

export default node;
